import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Search, Target, Cog, HeadphonesIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

const ProcessSection = () => {
  const { t } = useTranslation('misc');
  
  const steps = [
    {
      number: "01",
      icon: Search,
      title: t('process.steps.0.title'),
      description: t('process.steps.0.description')
    },
    {
      number: "02", 
      icon: Target,
      title: t('process.steps.1.title'),
      description: t('process.steps.1.description')
    },
    {
      number: "03",
      icon: Cog,
      title: t('process.steps.2.title'), 
      description: t('process.steps.2.description')
    },
    {
      number: "04",
      icon: HeadphonesIcon,
      title: t('process.steps.3.title'),
      description: t('process.steps.3.description')
    }
  ];

  return (
    <section id="process" className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <Badge variant="outline" className="mb-4">{t('process.badge')}</Badge>
          <h2 className="text-4xl font-bold mb-6">{t('process.title')}</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            {t('process.description')}
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, index) => {
            const IconComponent = step.icon;
            return (
              <Card key={index} className="relative hover:shadow-elegant transition-smooth group">
                <CardHeader className="text-center pb-4">
                  <div className="flex items-center justify-center w-16 h-16 bg-gradient-golden rounded-xl mb-4 mx-auto shadow-golden">
                    <IconComponent className="w-8 h-8 text-accent-foreground" />
                  </div>
                  <div className="absolute top-4 right-4 text-4xl font-bold text-muted-foreground/70 group-hover:text-primary transition-smooth">
                    {step.number}
                  </div>
                  <CardTitle className="text-xl">{step.title}</CardTitle>
                </CardHeader>
                <CardContent className="text-center">
                  <CardDescription className="text-base">
                    {step.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;